import { render } from "./Specialisms.vue?vue&type=template&id=6a743d32&scoped=true"
import script from "./Specialisms.vue?vue&type=script&lang=js"
export * from "./Specialisms.vue?vue&type=script&lang=js"

import "./Specialisms.vue?vue&type=style&index=0&id=6a743d32&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a743d32"]])

export default __exports__